import { render, staticRenderFns } from "./MonitoringSkeleton.vue?vue&type=template&id=38129b82&scoped=true&"
import script from "./MonitoringSkeleton.vue?vue&type=script&lang=js&"
export * from "./MonitoringSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringSkeleton.vue?vue&type=style&index=0&id=38129b82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38129b82",
  null
  
)

export default component.exports